export default __webpack_public_path__ + "static/media/platinum_card_selected.05f9642d.png";